import JellyBelly from "./JellyBelly";

export default {
    get: id => {
        let modal_id  = '#modal-' + id;
        let modal_dom = document.querySelector(modal_id);

        if (modal_dom) {
            let modal = {
                body:          modal_dom.querySelector('.modal-body'),
                $:             $(modal_dom),
                close:         modal_dom.querySelector('.modal-footer .modal-close'),
                dom:           modal_dom,
                errors:        null,
                hide:          null,
                error_dom:     modal_dom.querySelector('.js-error'),
                form:          modal_dom.querySelector('form'),
                querySelector: modal_id,
                save:          modal_dom.querySelector('.modal-save'),
                show:          null,
                title:         modal_dom.querySelector('.modal-title'),
            };

            modal.errors = errors => {
                let html = '';

                JellyBelly.set_hidden(modal.error_dom);

                if (errors) {
                    html += '<p>We couldn\'t submit the form due to the following reasons</p>';
                    html += '<ul class="mb-0">';

                    if (errors.global_errors) {
                        html += '<li>' + errors.global_errors.join('</li><li>') + '</li>';
                    }

                    html += '</ul>';

                    JellyBelly.unset_hidden(modal.error_dom);
                }

                modal.error_dom.innerHTML = html;
            }

            modal.hide = () => {
                modal.$.modal('hide');
            };

            modal.show = () => {
                modal.$.modal('show');
            };

            return modal;
        } else {
            return null;
        }
    }
};
